import React from 'react';

import footer from './Footer.module.scss';
import strings from 'lang/lang';

import ContactLinks from './ContactLinks';
import SocialLinks from './SocialLinks';
import ProductsLinks from './ProductsLinks';
import ResourcesLinks from './ResourcesLinks';
import SolutionsLinks from './SolutionsLinks';
import PlatformLinks from './PlatformLinks';
import UseCasesLinks from './UseCasesLinks';

const FooterList = () => {
  return (
    <div className={footer.footer__list}>
      <div className={footer.footer__list_item}>
        <div>
          <strong>{strings.footerList.text.contact}</strong>
          <ContactLinks />
        </div>
        <div>
          <strong>{strings.footerList.text.socialIcons}</strong>
          <SocialLinks />
        </div>
      </div>
      <div className={footer.footer__list_item}>
        <div>
          <strong>{strings.footerList.text.productsTitle}</strong>
          <ProductsLinks />
        </div>
        <div>
          <strong>{strings.footerList.text.resources}</strong>
          <ResourcesLinks />
        </div>
      </div>
      <div className={footer.footer__list_item}>
        <div>
          <strong>{strings.footerList.text.solutions}</strong>
          <SolutionsLinks />
        </div>
        <div>
          <strong>{strings.footerList.text.platform}</strong>
          <PlatformLinks />
        </div>
      </div>
      <div className={footer.footer__list_item}>
        <div>
          <strong>{strings.footerList.text.cases}</strong>
          <UseCasesLinks />
        </div>
      </div>
    </div>
  );
};

export default FooterList;
